<template>
  <section class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.isCache === 'Y'" />
    </keep-alive>
    <router-view v-if="$route.meta.isCache !== 'Y'" />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppMain',
  data() {
    return {
      pageArr: [
        'DoctorList',
        'TargetList',
        'DoctorRecordList',
        'StaffRecordList',
        'authList',
      ],
    };
  },
  computed: {
    ...mapGetters({
      cacheList: 'cacheList',
      isCollapse: 'isCollapse',
    }),
    isCache() {
      return this.cacheList.includes(this.$route.path);
    }
  }
};
</script>

<style lang="less" scoped>
  .app-main {
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    padding: 0 12px;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/AppMain.vue